import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import BookingStatusBadge from './BookingStatusBadge';
import dayjs from 'dayjs';

const BookingCard = ({ booking, onApprove, onReject, onViewReceipt, showActions = true }) => {
  // فرمت تاریخ شمسی با استفاده از سیستم داخلی یا جاوااسکریپت استاندارد
  const getFormattedDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fa-IR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch {
      return dateString;
    }
  };

  const getFormattedTime = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleTimeString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    } catch {
      return '';
    }
  };

  const isReview = booking.status === 'review';
  const isPending = booking.status === 'pending';

  return (
    <div className="bg-card border border-border rounded-xl p-4 flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow relative" dir="rtl">
      {/* Top row: Status and order type */}
      <div className="flex justify-between items-start mb-3">
        <BookingStatusBadge status={booking.status} />
        {booking.orderType === 'gift' && (
          <span className="bg-primary/10 text-primary border border-primary/20 text-[10px] px-2 py-0.5 rounded-md font-medium flex items-center gap-1">
            <Icon name="Gift" size={10} />
            سفارش هدیه
          </span>
        )}
      </div>

      {/* Booking Details */}
      <div className="space-y-2 mb-4 text-sm">
        <div className="flex items-center gap-2 text-foreground font-semibold">
          <Icon name="User" size={16} className="text-muted-foreground" />
          <span>{booking.clientName}</span>
          {booking.clientPhone && (
            <span className="text-xs text-muted-foreground font-normal" dir="ltr">
              ({booking.clientPhone})
            </span>
          )}
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <Icon name="Scissors" size={14} />
            <span className="truncate">سرویس: <strong className="text-foreground">{booking.service?.name || booking.service}</strong></span>
          </div>
          <div className="flex items-center gap-1.5">
            <Icon name="UserCircle2" size={14} />
            <span className="truncate">کارمند: <strong className="text-foreground">{booking.employee?.name || booking.employee}</strong></span>
          </div>
        </div>

        <div className="border-t border-border/50 my-2 pt-2 grid grid-cols-2 gap-2 text-xs text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <Icon name="Calendar" size={14} />
            <span>{getFormattedDate(booking.start)}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Icon name="Clock" size={14} />
            <span>ساعت: <strong className="text-foreground">{getFormattedTime(booking.start)}</strong></span>
          </div>
        </div>

        {booking.notes && (
          <div className="bg-muted/40 p-2 rounded text-xs text-muted-foreground border border-border/30">
            <strong>توضیحات:</strong> {booking.notes}
          </div>
        )}
      </div>

      {/* Action buttons or receipt link */}
      <div className="flex items-center gap-2 pt-3 border-t border-border/50">
        {/* If receipt exists, show button to view it */}
        {booking.receiptUrl && onViewReceipt && (
          <Button
            variant="outline"
            size="sm"
            className="flex-1 text-xs gap-1"
            iconName="Receipt"
            onClick={() => onViewReceipt(booking)}
          >
            مشاهده رسید
          </Button>
        )}

        {/* Action Buttons for pending/review cases */}
        {showActions && (isReview || isPending) && (
          <>
            <Button
              variant="success"
              size="sm"
              className={booking.receiptUrl ? 'flex-1' : 'w-1/2'}
              iconName="Check"
              onClick={() => onApprove(booking._id)}
            >
              تایید
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="w-1/2"
              iconName="X"
              onClick={() => onReject(booking._id)}
            >
              رد رزرو
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingCard;
